export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(n) || 0);

export const monthLabel = (m) => {
  const [y, mo] = String(m || "").split("-").map(Number);
  if (!y || !mo) return m;
  return new Date(y, mo - 1, 1).toLocaleString("en-IN", { month: "long", year: "numeric" });
};

export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const daysOf = (m) => {
  const [y, mo] = m.split("-").map(Number);
  const n = new Date(y, mo, 0).getDate();
  return Array.from({ length: n }, (_, i) => `${m}-${String(i + 1).padStart(2, "0")}`);
};

export const STATUS_LABEL = { present: "Present", half_day: "Half day", leave: "Leave", absent: "Absent" };

export const STATUS_TONE = {
  present: "text-emerald-300 border-emerald-400/60",
  half_day: "text-[var(--signal)] border-[var(--signal)]/60",
  leave: "text-sky-300 border-sky-400/60",
  absent: "text-red-300 border-red-400/60",
};

export const summarize = (records) =>
  (Array.isArray(records) ? records : []).reduce(
    (acc, r) => ({ ...acc, [r.status]: (acc[r.status] || 0) + 1 }),
    { present: 0, half_day: 0, leave: 0, absent: 0 },
  );

export const paidDaysFrom = (records) => {
  const s = summarize(records);
  return s.present + s.half_day * 0.5;
};

export const boxInput =
  "w-full border border-white/15 bg-transparent px-3 py-2 text-sm text-[var(--bone)] placeholder:text-[#8f8a7e] focus:border-[var(--signal)] focus:outline-none [&>option]:bg-[var(--ink)]";
